import { api, loginRequest } from '@/api/client';

export const AuthAPI = {
  versionCheck: (deviceOS: 0 | 1 | 2) => api.get('/MontanstahlPeopleInfo/IsVersionValid', { params: { appVersion: '2.0.0', deviceOS } }),
  login: (username: string, password: string) => loginRequest(username, password),
  changePassword: (oldPassword: string, newPassword: string) => api.post('/auth/change-password', { oldPassword, newPassword }),
};
